export enum ResidentDetailsTabIndex {
  Details = 0,
  Coverages = 1,
  Documents = 2,
  PhysicalMailNotificationEvents = 3,
}
